const themeDarkNotificationError = '#FC4040';

export { themeDarkNotificationError };
